import type { LocaleStrings } from '@/types';

export const useStrings = (): LocaleStrings => {
	const data = typeof window !== 'undefined' ? window.mocyRevocationData : undefined;
	return (data && data.strings) || {};
};

export const t = (strings: LocaleStrings, key: string, fallback: string, replacements?: Record<string, string>): string => {
	const raw = strings[key] || fallback;
	if (!replacements) {
		return raw;
	}
	return Object.entries(replacements).reduce(
		(acc, [placeholder, value]) => acc.replace(`{${placeholder}}`, value),
		raw
	);
};
